import { useState } from "react";
import { CheckCircle, PaperPlaneTilt } from "@phosphor-icons/react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";

export default function BookingForm({ type = "servicing", accent = "Book Your Slot" }) {
  const [form, setForm] = useState({ name: "", email: "", phone: "", date: "", bike_model: "", details: "" });
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/bookings", { type, ...form });
      setDone(true);
      toast.success("Booking request sent! We'll confirm your slot shortly.");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally { setBusy(false); }
  };

  if (done) {
    return (
      <div className="rounded-3xl border border-border bg-card p-8 text-center" data-testid="booking-success">
        <CheckCircle size={56} weight="fill" className="mx-auto text-green-500" />
        <h3 className="mt-4 text-2xl font-black">Request received!</h3>
        <p className="mt-2 text-muted-foreground">Thanks {form.name.split(" ")[0]}. Our team will be in touch shortly to confirm your {type} appointment.</p>
        <button onClick={() => { setDone(false); setForm({ name: "", email: "", phone: "", date: "", bike_model: "", details: "" }); }} className="btn-outline mt-6">Book another</button>
      </div>
    );
  }

  return (
    <form onSubmit={submit} className="rounded-3xl border border-border bg-card p-6 sm:p-8 shadow-soft" data-testid="booking-form">
      <h3 className="text-2xl font-black tracking-tight">{accent}</h3>
      <p className="mt-1 text-sm text-muted-foreground">Fill in your details and we'll get you booked in fast.</p>
      <div className="mt-6 grid gap-4 sm:grid-cols-2">
        <input required placeholder="Full name" value={form.name} onChange={set("name")} className="rounded-xl border border-border bg-background px-4 py-3 text-sm outline-none focus:border-primary" data-testid="booking-name" />
        <input required type="email" placeholder="Email" value={form.email} onChange={set("email")} className="rounded-xl border border-border bg-background px-4 py-3 text-sm outline-none focus:border-primary" data-testid="booking-email" />
        <input placeholder="Phone" value={form.phone} onChange={set("phone")} className="rounded-xl border border-border bg-background px-4 py-3 text-sm outline-none focus:border-primary" data-testid="booking-phone" />
        <input type="date" value={form.date} onChange={set("date")} className="rounded-xl border border-border bg-background px-4 py-3 text-sm outline-none focus:border-primary" data-testid="booking-date" />
        <input placeholder="Bike make & model" value={form.bike_model} onChange={set("bike_model")} className="sm:col-span-2 rounded-xl border border-border bg-background px-4 py-3 text-sm outline-none focus:border-primary" data-testid="booking-model" />
        <textarea rows={3} placeholder="Describe the issue or service needed" value={form.details} onChange={set("details")} className="sm:col-span-2 rounded-xl border border-border bg-background px-4 py-3 text-sm outline-none focus:border-primary" data-testid="booking-details" />
      </div>
      <button disabled={busy} className="btn-primary mt-6 w-full" data-testid="booking-submit">
        {busy ? "Sending…" : <>Submit Request <PaperPlaneTilt size={16} /></>}
      </button>
    </form>
  );
}
